module.exports = __webpack_public_path__ + "static/media/matilde-special-indiana-hello.b7d986eb.png";